import FarmInformationBar from './FarmInformationBar';

export default FarmInformationBar;
